import type { SVGProps } from 'react';
const DawnFlagBG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect
      width={21.5}
      height={15.5}
      x={0.25}
      y={0.25}
      fill="#fff"
      stroke="#F5F5F5"
      strokeWidth={0.5}
      rx={1.75}
    />
    <mask
      id="dawn-flag-BG_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-BG_svg__a)">
      <path fill="#06A77C" d="M0 10.667h22V5.333H0z" />
      <path fill="#E32E19" d="M0 16h22v-5.333H0z" />
    </g>
  </svg>
);
export default DawnFlagBG;
